$(document).ready(function()
{
    $( '#loadJotForm, .loadJotForm' ).on( 'click', function () 
    {
        var url = "https://form.jotform.com/jsform/221854120087350";
        //$('#jotFormScript').attr('src', url);
    });
});